// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:18:44

export default {
  "id": "solitaire-klondike-treasure-island",
  "slug": "solitaire-klondike-treasure-island",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cfca20a86e8349cfa78eaec18fec60d1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cfca20a86e8349cfa78eaec18fec60d1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Solitaire Klondike - Treasure Island",
      "description": "Set sail on a thrilling pirate adventure! Explore mysterious islands, uncover hidden treasures, and help a fearless heroine escape ruthless villains.\nCustomize your experience with beautifully illustrated card decks, stunning animations, and magical boosters to tackle challenges.\nRelax between games with mesmerizing music and lively animated characters. Dive into a world of adventure, mystery, and enchantment!",
      "instructions": "Sort all cards into four suit piles from Ace to King. Move cards between seven stacks, alternating colors and descending ranks. Groups of cards can be moved for strategic plays. Review the deck as needed and enjoy the challenge of mastering this classic solitaire game!",
      "genres": [
        "Cards"
      ],
      "tags": [
        "matching",
        "pirate",
        "solitaire",
        "story"
      ]
    },
    "zh-CN": {
      "title": "纸牌游戏-克朗代克 - 宝藏岛",
      "description": "扬帆起航，踏上惊险的海盗冒险之旅！探索神秘岛屿，发现隐藏的宝藏，并帮助一位勇敢的女英雄逃离残忍的恶棍。\n\n通过精美插画卡片、震撼动画和神奇增益道具，定制您的游戏体验，应对挑战。\n\n游戏间隙，沉浸在迷人的音乐和活泼的动画角色之中放松身心。进入一个充满冒险、神秘和魔法的世界！",
      "instructions": "将所有牌按从A到K的顺序分入四种花色的牌堆。在七个堆之间移动牌，交替颜色和按降序排列。可以移动牌组进行战略操作。根据需要查看牌组，享受掌握这个经典单人纸牌游戏的挑战！",
      "genres": [
        "牌"
      ],
      "tags": [
        "匹配",
        "海盗",
        "单人纸牌游戏",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "單人牌局 - 寶藏島",
      "description": "啟航於刺激的 pirate 遊戲冒險！探索神秘島嶼，挖掘隱藏的寶藏，並幫助一位無畏的女英雄逃離無情惡棍。\n使用美麗插畫的卡牌組、驚艷的動畫和神奇加強劑，量身定製您的體驗，應對挑戰。\n遊戲之間，享受迷人的音樂和活躍的動畫角色來放鬆。深入一個充滿冒險、謎團和魔法的世界！",
      "instructions": "將所有牌分為四種花色的牌堆，從A到K。在七個牌堆之間移動卡片，交替顏色和降序排名。可以為策略性遊戲移動卡片組。隨時檢查牌組，並享受精通這款經典单人遊戲的挑戰！",
      "genres": [
        "牌"
      ],
      "tags": [
        "配對",
        "海盜",
        "單人牌局",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "純牌克勞迪克 - 寶藏島",
      "description": "啟航於刺激的盜賊冒險！探索神秘島嶼，挖掘隱藏的寶藏，並幫助一位無畏的女英雄逃離殘忍的惡棍。\n透過美麗繪畫的卡牌組、驚艷的動畫和魔法加強器，自訂您的體驗，挑戰各種挑戰。\n遊戲之間，享受迷人的音樂和生動的動畫角色，放鬆心情。墜入冒險、謎團和魔法的世界！",
      "instructions": "將所有牌按四種花色分組，從A到K排序。在七個塔之間移動牌，交替顏色和降序排名。可以為戰術目的移動牌組。隨時檢查牌堆，享受掌握這款經典單人遊戲的挑戰！",
      "genres": [
        "牌"
      ],
      "tags": [
        "配對",
        "海盜",
        "獨奏曲",
        "故事"
      ]
    },
    "ja": {
      "title": "ソリタリークロノーク - 宝島",
      "description": "冒険の旅に出て、興奮する海賊の冒険に参加しよう！神秘的な島々を探検し、隠された宝を見つけ、無慈悲な悪党から勇気あるヒロインを助けよう。\n\n美しく描かれたカードデッキ、圧巻のアニメーション、そして魔法のボーナスで挑戦に立ち向かって、あなたの体験をカスタマイズしよう。\n\nゲームの合間に魅力的な音楽と活発なアニメーションキャラクターでリラックスしよう。冒険、謎、魔法の世界に飛び込みよう！",
      "instructions": "エースからキングまでのカードを4つのスートの山に並べ替え、7つのスタック間で色を交互に、ランクを降順にカードを移動させます。カードのグループを戦略的に移動させることができます。必要に応じてデッキを確認し、この古典的なソロイタリーゲームをマスターする挑戦を楽しんでください！",
      "genres": [
        "カード"
      ],
      "tags": [
        "マッチング",
        "海賊",
        "スリート",
        "物語"
      ]
    },
    "ko": {
      "title": "솔리테어 클론디크 - 트레저아일랜드",
      "description": "파이어나인: 더 블러드 라이드를 타고, 흥미진진한 해적 모험을 떠나세요! 음모적인 섬을 탐험하고 숨겨진 보물을 발견하며 용감한 여성 영웅이 무자비한 악당들로부터 탈출하는 도움을 드립니다.\n\n미니어처 그림이 아름다운 카드 덱, 장관적인 애니메이션, 마법적인 보스터를 통해 도전을 맞서는 경험을 맛보세요. 게임 사이에 휴식을 취하며 매혹적인 음악과 생동감 넘치는 애니메이션 캐릭터들과 함께하세요. 모험, 미스터리, 마법의 세계로 뛰어들세요!",
      "instructions": "어스에서 킹까지의 카드를 네 가지 패빌리온에 정리하세요. 일곱 쌓기 간에 색과 등급을 번갈아 이동하세요. 전략적인 플레이를 위해 카드 그룹을 이동할 수 있습니다. 필요에 따라 덱을 확인하고 이 클래식 솔리테어 게임을 완성하는 도전을 즐겨보세요!",
      "genres": [
        "카드"
      ],
      "tags": [
        "매칭",
        "해적",
        "솔리테어",
        "이야기"
      ]
    },
    "fr": {
      "title": "Solitaire Klondike - Île au Trésor",
      "description": "Partez à l'aventure pirate captivante ! Explorez des îles mystérieuses, découvrez des trésors cachés et aidez une héroïne intrépide à échapper aux méchants sans pitié.\nPersonnalisez votre expérience avec des deck de cartes magnifiquement illustrés, des animations époustouflantes et des boosters magiques pour affronter les défis.\nRelâchez-vous entre les parties avec une musique envoûtante et des personnages animés vivants. Plongez dans un monde d'aventure, de mystère et d'enchantement !",
      "instructions": "Triez toutes les cartes en quatre piles de couleurs, de l'As au Roi. Déplacez les cartes entre sept piles, en alternant les couleurs et en descendant par rang. Des groupes de cartes peuvent être déplacés pour des parties stratégiques. Consultez le jeu au besoin et profitez du défi de maîtriser ce classique du jeu de solitaire !",
      "genres": [
        "Cartes"
      ],
      "tags": [
        "juxtaposition",
        "pirate",
        "solitaire",
        "histoire"
      ]
    }
  }
};
